import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { Routes } from '../../../routing/routes'
import { Plann3rStore } from '../../../store/types'

const DataTab: FC = () => {
  const history = useHistory()
  const strings = useSelector(
    (state: Plann3rStore) => state.languages.strings.settings.settings,
  )

  return (
    <div className="mydata">
      <div className="column settingsbox">
        <h3>{strings.my_data}</h3>
        <p>{strings.data_statement}</p>
        <div>
          <a
            className="button is-primary"
            href="mailto:data@plann3r.com?subject=Request Data"
            target="_blank"
            rel="noopener noreferrer"
          >
            {strings.request_data}
          </a>
          <a
            className="button is-primary is-outlined"
            href="mailto:data@plann3r.com?subject=Request Information"
            target="_blank"
            rel="noopener noreferrer"
          >
            {strings.request_information}
          </a>
          <a
            className="button is-danger"
            href="mailto:data@plann3r.com?subject=Delete Account"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => {
              history.push(Routes.LOGOUT)
            }}
          >
            {strings.request_deletion}
          </a>
        </div>
        <div>
          <a href="/privacy" target="_blank" rel="noopener noreferrer">
            {strings.privacy}
          </a>
          <a href="/cookie" target="_blank" rel="noopener noreferrer">
            {strings.cookie}
          </a>
        </div>
      </div>
    </div>
  )
}

export default DataTab
